/** @jsx dom */
import debounce from 'debounce';
import dom from 'magic-virtual-element';
import page from 'page';
import {Cell, Grid} from 'viskan-deku-grid';
import {utils as cmsUtils} from '@viskan/cms-components';

const propTypes = {
	getPrice: {
		source: 'getPrice'
	}
};

const initialState = () => ({
	subscription: {}
});

const onClick = (subscription, setState) => () => setState({subscription});

const getSubscriptions = (props, setState) => {
	const descriptionClass = 'CMS-Subscription-description';
	const active = props.subscriptions[0].prentype_id;

	return props.subscriptions.map(subscription => {
		const classes = {
			'Subscription-option': true,
			'Subscription-option--active': active === subscription.prentype_id
		};

		return (
			<div key={subscription.prentype_id} class={['FormField RadioField', classes]}>
				<div class='FormField-controls u-cf'>
					<Grid gutter>
						<Cell size='2of12'>
							<div class='SC-align-center'>
								<label for={subscription.prentype_id} class='Subscription-option-label'>
									<input class='Subscription-option-button' type='radio' name='prentype_id' id={subscription.prentype_id} value={subscription.prentype_id} checked={subscription.prentype_id === active} onClick={onClick(subscription, setState)}/>
								</label>
							</div>
						</Cell>
						<Cell size='10of12'>
							{props.showDescription1 && <div class={[descriptionClass, `${descriptionClass}--1`, props.styleClasses.Description1]} data-style-attr='Description1' innerHTML={subscription.prentype_desc}/>}
							{props.showDescription2 && <div class={[descriptionClass, `${descriptionClass}--2`, props.styleClasses.Description2]} data-style-attr='Description2' innerHTML={subscription.prentype_desc2}/>}
							{props.showDescription3 && <div class={[descriptionClass, `${descriptionClass}--3`, props.styleClasses.Description3]} data-style-attr='Description3' innerHTML={subscription.prentype_desc3}/>}
							<div class={['CMS-Subscription-price']} data-style-attr='Price'>
								{props.showPrice && props.getPrice(subscription.prognoses[0].price)}
							</div>
						</Cell>
					</Grid>
				</div>
			</div>
		);
	});
};

const afterMount = ({props}, el, setState) => {
	if (!props.subscriptions[0]) {
		return <noscript/>;
	}
	setState({subscription: props.subscriptions[0]});
};

const render = ({props, state}, setState) => {
	const {subscription} = state;
	const {hideOutOfStockButton, inStock, outOfStockMessage} = props;

	if (!props.articleIsLoaded || !props.subscriptions[0]) {
		return <noscript/>;
	}

	const onClick = () => props.addToCart(subscription).then(() => props.goToCheckout && page('/checkout'));

	if (hideOutOfStockButton && !inStock) {
		return cmsUtils.createCmsComponent((
			<div class={['CMS-Article-outOfStockMessage', props.class, props.styleClasses.Container]} data-style-attr='Container'>
				{outOfStockMessage}
			</div>
		), props);
	}

	return cmsUtils.createCmsComponent((
		<fieldset class='Subscriptions'>
			<div class='Subscription-header'>
				{props.Header}
			</div>
			<div class={['CMS-Subscription-options', props.class, props.styleClasses.Wrapper]} data-style-attr='Wrapper'>
				{getSubscriptions(props, setState)}
			</div>

			<button type='button' class={['Button CMS-Subscription-buyButton', props.styleClasses.Button]} disabled={!inStock} onClick={debounce(onClick, 1000, true)} data-style-attr='Button'>
				{inStock ? props.buttonText : props.outOfStockButtonText}
			</button>
		</fieldset>
	), props);
};

export default {afterMount, propTypes, render, initialState};
